module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_header", [["a",{"href":"/","class":"logo"},[["img",{"src":"" + require('../../images/models-xxx-logo.png') + "","alt":""}]]],["div",{"class":"title"},[["textNode",{"text":"Home Of "}],["strong",{},[["textNode",{"text":"Authentic Model"}]]],["textNode",{"text":" Operated Websites"}]]],["span",{"class":"menu-icon"},[["span",{},[["textNode",{"text":"Menu"}]]],["textNode",{"text":" "}],["i",{"class":"icon-xxx-08"}]]],["nav",{"id":"navigation","class":"navigation"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/catalog/header.tpl
// module id = 96
// module chunks = 0